var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67411 21.3661V12.0714H6.76786V21.3661H3.67411ZM6.96875 9.20536C6.96875 10.0893 6.29911 10.8125 5.21429 10.8125H5.20089C4.15625 10.8125 3.48661 10.0893 3.48661 9.20536C3.48661 8.29464 4.18304 7.59821 5.24107 7.59821C6.29911 7.59821 6.95536 8.29464 6.96875 9.20536ZM14.8036 21.3661V16.3973C14.8036 15.1384 14.3616 14.2946 13.25 14.2946C12.3929 14.2946 11.8839 14.8705 11.6563 15.4196C11.5759 15.6205 11.5625 15.9018 11.5625 16.1696V21.3661H8.46875C8.50893 12.942 8.46875 12.0714 8.46875 12.0714H11.5625V13.4241H11.5357C11.9375 12.7812 12.6741 11.8571 14.3348 11.8571C16.3705 11.8571 17.8973 13.183 17.8973 16.0357V21.3661H14.8036ZM21.0714 8C21.0714 5.87053 19.3438 4.14286 17.2143 4.14286H4.35714C2.22768 4.14286 0.5 5.87053 0.5 8V20.8571C0.5 22.9866 2.22768 24.7143 4.35714 24.7143H17.2143C19.3438 24.7143 21.0714 22.9866 21.0714 20.8571V8Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.45c063df52d82827ccb2f5111d6a5ba0.svg";
export { ForwardRef as ReactComponent };